import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

class Delete extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete() {
    this.props.onDelete();
  }

  render() {
    return (
      <button
        className={['button is-danger'].concat(this.props.classNames || []).join(' ')}
        disabled={this.props.disabled}
        title={this.props.title}
        onClick={this.handleDelete}
        data-confirm={this.props.confirm}
      >
        <Icon icon="trash" />
      </button>
    );
  }
}

Delete.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  onDelete: PropTypes.func,
  title: PropTypes.string,
  confirm: PropTypes.string
};

export default Delete;
